import React from "react";

export function LandingPage({ onEnter }: { onEnter: () => void }) {
	return (
		<div className="landing">
			<div className="landing-sun" aria-hidden="true" />
			<h1 className="landing-title">RK Beach Rampage</h1>
			<p className="landing-subtitle">
				A retro pixel-art beach race. Dash the shoreline solo, or go head-to-head for the finish line.
			</p>
			<button className="landing-cta blink-text" onClick={onEnter}>
				Press Start
			</button>
			<p className="landing-footer">© RK Beach Rampage — insert coin to continue</p>
			<div className="rotate-device-overlay">
				<div className="rotate-device-icon" aria-hidden="true">
					⟳
				</div>
				<p>Rotate your device to landscape for the best experience</p>
			</div>
		</div>
	);
}
